'use client';

import React from 'react';
import { useStoreData } from '@wwe-portal/web/hooks/offer/use-store-data';
import { useLimitedEventV2 } from '@wwe-portal/web/hooks/rbe/use-limited-events';
import { useIsAuthenticating } from '@wwe-portal/web/providers/stores/auth-store';
import { StoreRevampSkeleton } from '@wwe-portal/widget/store-revamp';
import { useCurrentCurrency } from '@wwe-portal/web/hooks/global/use-current-currency';

export const SpecialOffersPageContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isLoading: isLoadingStoreData } = useStoreData();
  const { isLoading: isLoadingRbe } = useLimitedEventV2();
  const isAuthenticating = useIsAuthenticating();
  const { isLoading: isLoadingCurrency } = useCurrentCurrency();
  const loading =
    isAuthenticating || isLoadingStoreData || isLoadingRbe || isLoadingCurrency;

  if (loading) {
    return <StoreRevampSkeleton />;
  }
  return <>{children}</>;
};
